var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',{attrs:{"width":"24","height":"24","fill":_vm.getSponsorPattern(_vm.p),"data-stop":_vm.s.title,"transform":_vm.pipeRectTranslation(_vm.pIdx, _vm.p.tone_ref.list[0].index)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f658e12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PipeRect.vue
// module id = IsQM
// module chunks = 1